import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { useDtpDetailModel } from "./dtpDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Button, Checkbox, message, Modal, Radio } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { useDictModel } from "@/views/base/dict/dictModel";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import TextArea from "antd/lib/input/TextArea";
import { useDrodDetailModel } from "@/views/document/refundOfDuty/view/details/drodDetailModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const { editFormVal, auditFields, editList, showDoc, insertOrUpdateDtp, getDtpDetailOne, resetPageCache, exportOrder, transferDrawback, onCreateBills, submitCustoms, examineManager, examineReckoner, } = useDtpDetailModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { getTreeNodeName } = useDictModel(() => []);
    const { updateFormVal: drodUpdateFormVal } = useDrodDetailModel(() => []);

    useEffect(() => {
        if (!editFormVal.id && mode === "edit") {
            getDtpDetailOne(id)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("9-2-1") && resetPageCache("add")
            !findNav("9-2-2") && resetPageCache("edit");
        }
    }, [selectedNavId])

    const orderStatu: IDescription[] = [
        {
            label: "报关单据",
            value: editFormVal.code ?? "无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(editFormVal.status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
    ]


    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            insertOrUpdateDtp(mode, val).then(res => {
                if (mode === "add" && res) {
                    resetPageCache("edit");
                    replaceNav("9-2-1", "9-2-2", { id: res as string, mode: "edit" });
                }
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };


    //单据生成
    const onCreateDoc = () => {
        debugger
        formRef.current?.validateFields().then((val: any) => {
        const plainOptions = [{ label: "报关单", value: "customs_clearance" }, { label: "商业发票", value: "invoice" }, { label: "装箱单", value: "encasement" }];
        let arr: CheckboxValueType[] = ["customs_clearance", "invoice", "encasement"]
        const onChange = (list: CheckboxValueType[]) => {
            arr = [...list]
        };
        Modal.confirm({
            title: "所需单证",
            content: <Checkbox.Group options={plainOptions} onChange={onChange} defaultValue={arr} />,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    if (!arr.length) {
                        reject("请选择你要生成的单据");
                        message.warning("请选择你要生成的单据");
                    }
                    resolve(arr)
                }).then((res: any) => {
                    onCreateBills(res.join())
                });
            },
            onCancel: () => { }
        })
    }).catch((err: ValidateErrorEntity<any>) => {
        message.warning(getFormValidatorErrText(err));
    })
    }

    //报关单主单信息
    const clearanceObj: any = {
        prescoCode: "预录入编号",
        customsCode: "海关编号",
        supplierName: "境内发货人",
        exitType: "出境关别",
        departureTime: "出口日期",
        declareTime: "申报日期",
        recordVarchar: "备案号",
        customerName: "境内收货人",
        shipmentType: "运输方式",
        voyageNumber: "运输工具名称及航次号",
        deliveryNumber: "提运单号",
        supplierCode: "生产销售单位",
        supervisionMethod: "监管方式",
        exemptionType: "征免性质",
        licenseKey: "许可证号",
        saleCode: "合同协议号",
        countryTrade: "贸易国",
        destinationCountry: "运抵国",
        dischargingPort: "指运港",
        portDeparture: "高境口岸",
        packageType: "包装种类",
        num: "件数",
        roughWeight: "毛重",
        suttle: "净重",
        transactionType: "成交方式",
        freight: "运费",
        premium: "保费",
        incidentals: "杂费",
        documentsNum: "随附单证及编号",
        labelNote: "标记唛码及备注",
        relationshipAffirm: "特殊关系确认",
        priceAffirm: "价格影响确认",
        payAffirm: "支付特许权使用费确认",
        declareType: "自报自缴",
    };

    const detailsAuditObj: any = {
        "CustomsCode": '商品编号',
        "MaterialName": '商品名称及规格型号',
        "Num": '数量及单位',
        "Price": '单价/总价/币制',
        "OriginCountry": '原产国(地区)',
        "DestinationCountry": '最终目的国(地区)',
        "SourceSupply": '境内货源地',
        "ShallBe": '征免'
    }
    //经理
    const examineModal1 = (title: string) => {
        console.log(auditFields)
        if (showDoc.customs_clearance && Object.keys(auditFields).length !== (34 + editList.length * 8)) {
            let TempClearanceObj = { ...clearanceObj };
            let str = "";
            //商品的每条信息动态添加需要提示里面
            editList.forEach(item => {
                for (let prop in detailsAuditObj) {
                    TempClearanceObj[item.id + prop] = `商品:${item.materialName}[${detailsAuditObj[prop]}]`;
                }
            })
            //查询主单的每一项是否审核
            for (let prop in TempClearanceObj) {
                let field = prop as string
                if (!(prop in auditFields)) {
                    str = TempClearanceObj[field]
                    break;
                }
            }
            message.warning(`请逐项审批完后再进行审核提交，【${str}】还没有审核`)
            return;
        }

        let status = "0";
        let advise = "";
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { advise = e.target.value }} />
                <Radio.Group onChange={(e) => { status = e.target.value }} defaultValue={status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    resolve({
                        status, advise
                    });
                }).then((res: any) => {
                    examineReckoner(res.status, res.advise)
                });
            },
            onCancel: () => { }
        })
    }
    //总监
    const examineModal2 = (title: string) => {
        if (showDoc.customs_clearance && Object.keys(auditFields).length !== (30 + editList.length)) {
            let TempClearanceObj = { ...clearanceObj };
            let str = "";
            //商品的每条信息动态添加需要提示里面
            editList.forEach(item => {
                TempClearanceObj[item.id ?? ""] = "商品:" + item.materialName;
            })
            //查询主单的每一项是否审核
            for (let prop in TempClearanceObj) {
                let field = prop as string
                if (!(prop in auditFields)) {
                    str = TempClearanceObj[field]
                    break;
                }
            }
            message.warning(`请逐项审批完后再进行审核提交，【${str}】还没有审核`)
            return;
        }
        let status = "0";
        let advise = "";
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { advise = e.target.value }} />
                <Radio.Group onChange={(e) => { status = e.target.value }} defaultValue={status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    resolve({
                        status, advise
                    });
                }).then((res: any) => {
                    examineManager(res.status, res.advise)
                });
            },
            onCancel: () => { }
        })
    }

    const action = <>
        {mode === "edit" && <>
            <YhAuth resCode={ResourceAuthEnum.CUS_B_ED_OUT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={editFormVal.status !== "clearance-status.init" && editFormVal.status !== "clearance-status.dir-reject" && editFormVal.status !== "clearance-status.audit-reject"}
                    onClick={onCreateDoc}
                >单据生成</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.CUS_B_ED_SUB}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={editFormVal.status !== "clearance-status.generate"}
                    onClick={() => { submitCustoms() }}
                >提交审核</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.CUS_B_ED_TUBE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={editFormVal.status !== "clearance-status.to-Manager-audit"}
                    onClick={() => { examineModal1("经理审批") }}
                >经理审核</Button>
            </YhAuth>
            {/* <YhAuth resCode={ResourceAuthEnum.CUS_B_ED_LEAD}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={editFormVal.status !== "clearance-status.to-dir-audit"}
                    onClick={() => { examineModal2("总监审批") }}
                >总监审核</Button>
            </YhAuth> */}
            {/* <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={editFormVal.status !== "clearance-status.effect"}
                onClick={() => { exportOrder() }}
            >单据导出</Button> */}
            <YhAuth resCode={ResourceAuthEnum.CUS_B_ED_TURNT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={editFormVal.status !== "clearance-status.effect"}
                    onClick={() => {
                        transferDrawback().then(res => {
                            if (res) {
                                drodUpdateFormVal("edit", null)
                                replaceNav("9-2-2", "9-3-2", { id: res as string, mode: "edit" });
                            }
                        })
                    }}
                >转退税单据</Button>
            </YhAuth>
        </>}
        <YhAuth resCode={ResourceAuthEnum.CUS_B_ED_SAVE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { onSubmit() }}
            >保存</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "9-2")}
        >返回</Button>
    </>

    return (
        <YhBox
            title={orderStatu.map((item, index) => <Description key={index} {...item} />)}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}